import EmbedBlock, { EmbedBlockProps } from './embedBlock';
import EmbedBlockPlaceholder from './embedBlockPlaceholder';
import EmbedBlockValue from './embedBlockValue';

export default EmbedBlock;
export { EmbedBlockPlaceholder, EmbedBlockValue };
export type { EmbedBlockProps };
